import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import AccreditedInvestorIndexPage from '@buyside/components/presentation/AccreditedInvestorIndexPage/accreditedInvestorIndexPage';
import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';

import { accreditedInvestorProfilesIndexUrl } from '@buyside/util/urlHelper';

const AccreditedInvestorProfilesIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="accredited investors index">
      <Router basename={accreditedInvestorProfilesIndexUrl()}>
        <AccreditedInvestorIndexPage />
      </Router>
    </ErrorBoundary>
  );
};

export default AccreditedInvestorProfilesIndexPageRoot;
